import AdminWrapper from '@/components/Avatars/AdminWrapper';
import WinnerSpan from '@/components/WinnerSpan/WinnerSpan';
import { getUserColor } from '@/utils/colors';
import { IJackpotPlayer } from '@/utils/types/IJackpotPlayer';
import { toFullSteamAvatar } from '@/utils/avatar';
import Image from 'next/image';

interface Props {
    user: IJackpotPlayer;
    winner?: boolean;
    spanClassName?: string;
}

const HistoryAvatar = ({ user, winner, spanClassName }: Props) => {
    return (
        <AdminWrapper user={user}>
            <Image width={48} height={48} src={toFullSteamAvatar(user.avatar)} className={`rounded-full`} alt="" />
            {winner && (
                <WinnerSpan
                    className={spanClassName || 'absolute top-[-8px] left-0'}
                    color={getUserColor(user.experience) || ''}
                />
            )}
        </AdminWrapper>
    );
};

export default HistoryAvatar;
